import styled from 'styled-components'
import { borderRadiusSystem, colors } from '@/styles/theme'
import { tokens } from '@musinsa/layer-tokens/desktop'

export const TABLE_HEADER_EDITABLE = 'moms-header--editable'
export const TABLE_CELL_DISABLED = 'moms-cell--disabled'

export const GridTableV2Wrap = styled.div<{ $radius?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${colors.white};
  border-radius: ${({ $radius }) => $radius || '8px'};
  position: relative;
  overflow: hidden;

  &,
  & * {
    font-family: 'Pretendard', sans-serif;
  }
`

export const GridTitleWrap = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
`

export const GridTableHeaderWrap = styled.div`
  display: flex;
  width: 100%;
  height: 68px;
  padding: 12px 0px 12px 16px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
`

export const GridTableHeaderLeft = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${tokens.fg};
`

export const TableToolbarWrap = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
`

export const PageSizeSelect = styled.div`
  position: relative;
  min-width: 100px;
  width: 114px;

  button {
    height: 36px;
    font-family: Pretendard, sans-serif !important;
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 400 !important;
  }

  /* Select 컴포넌트 내부 텍스트 스타일 */
  * {
    font-family: Pretendard, sans-serif !important;
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 400 !important;
  }
`

export const SearchBarWrapper = styled.div`
  width: 200px;
`

export const AgGridReactWrapV2 = styled.div`
  flex: 1;
  width: 100%;
  height: 600px; /* 명시적인 높이 설정 */
  background-color: ${colors.white};
  --ag-font-family: 'Pretendard', sans-serif;

  .ag-icon:before {
    font-family: 'agGridBalham';
  }

  .ag-root-wrapper {
    border: none;
    height: 100%;
    overflow: hidden;
  }

  /* ag-grid 강제 높이 */
  .ag-root,
  .ag-body-viewport {
    height: 100% !important;
  }

  /* nodata 오버레이가 테이블 바깥으로 넘치지 않도록 제한 */
  .ag-overlay {
    overflow: hidden;
  }

  .ag-overlay-no-rows-wrapper {
    padding-top: 0 !important;
  }

  .ag-header {
    background: var(--layerDesktop-tableheader-bg, #f8f9fc);
    border-top: 1px solid ${tokens.stroke['border-low']};
    border-bottom: 1px solid ${tokens.stroke.border};
    min-height: 36px !important;
    height: auto !important;
  }

  .ag-header-row {
    background: var(--layerDesktop-tableheader-bg, #f8f9fc);
    height: 36px !important;
  }

  .ag-pinned-left-header,
  .ag-pinned-left-header .ag-header-cell {
    border-right: 1px solid ${tokens.stroke.divider};
  }

  .ag-header-cell {
    padding: 0 16px !important;
    line-height: 20px !important;

    &:not(:last-child) {
      border-right: 1px solid ${tokens.stroke.divider};
    }
  }

  /* AG Grid renders # (index) column as last DOM child due to absolute positioning —
     :not(:last-child) won't match it, so force the right border explicitly */
  .moms-index-col-header {
    border-right: 1px solid ${tokens.stroke.divider} !important;
  }

  .ag-header-cell-label {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    width: 100% !important;
    height: 100% !important;
  }

  .ag-header-cell-text {
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 500 !important;
    color: ${tokens.fg} !important;
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: nowrap !important;
  }

  /* resizable false인 컬럼의 리사이즈 핸들 숨기기 */
  .ag-header-cell::after,
  .ag-header-group-cell::after {
    display: none !important;
  }

  .ag-paging-panel {
    display: none;
  }

  .${TABLE_HEADER_EDITABLE} .ag-header-cell-text {
    color: ${tokens.fg};
  }

  // ROW
  .ag-center-cols-container {
    min-width: 100% !important;
  }

  .ag-row {
    min-height: 36px !important;
    height: auto !important;
    border-bottom: 1px solid ${tokens.stroke.divider};

    background-color: ${tokens.bg};

    &:hover {
      &::before {
        background-color: ${tokens.layerDesktop['bg-accent-low']};
      }
    }
  }

  // CELL
  .ag-cell {
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 400 !important;
    padding: 8px 16px !important;
    display: flex !important;
    align-items: center !important;

    &:not(.ag-cell-focus) {
      border-right: 1px solid ${tokens.stroke.divider} !important;
    }
  }

  .moms-checkbox-col-header {
    padding: 0 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;

    & > .ag-header-select-all {
      margin-right: 0px;
      .ag-checkbox-input-wrapper {
        left: 12px;
      }
    }

    .ag-header-cell-menu-button {
      display: none !important;
    }
  }

  .moms-checkbox-col-cell {
    padding: 8px 0 !important;

    & .ag-selection-checkbox {
      margin-right: 0px;
      .ag-checkbox-input-wrapper {
        left: 12px;
      }
    }
  }

  .ag-pinned-left-cols-container .ag-cell {
    &:not(.ag-cell-focus) {
      border-right: 1px solid ${tokens.stroke.divider};
    }
  }

  .${TABLE_CELL_DISABLED} {
    background-color: ${colors.gray100};
  }

  // CHECKBOX
  --ag-checkbox-indeterminate-color: ${colors.white};
  --ag-value-change-value-highlight-background-color: ${colors.blue500};

  .ag-checkbox-input-wrapper {
    position: relative;
    box-shadow: none;
    border: 1px solid ${tokens.stroke.border};
    border-radius: 2px;
    background-color: ${colors.white};

    &::after {
      content: none;
    }

    &.ag-checked {
      background-color: ${colors.black};
      border-color: ${colors.black};
    }

    &.ag-checked::after {
      content: '';
      display: block;
      position: absolute;
      top: 45%;
      left: 50%;
      width: 4px;
      height: 8px;
      border: solid ${colors.white};
      border-width: 0 2px 2px 0;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &.ag-indeterminate::after {
      display: none;
    }

    &.ag-disabled {
      background-color: ${tokens['bg-disabled']};
      border-color: ${colors.gray400};

      &.ag-checked {
        background-color: ${tokens['fg-disabled']};
        border-color: ${tokens['fg-disabled']};
      }
    }
  }
`

export const EmptyStateWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 180px 0;
  gap: 16px;
`

export const EmptyIconWrap = styled.div`
  width: 68px;
  height: 68px;
  display: flex;
  align-items: center;G
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const EmptyTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
`

export const EmptyTitle = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: ${tokens.fg};
`

export const EmptyDescription = styled.p`
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  color: ${tokens['fg-lower']};
  text-align: center;
`

export const GridToolBarWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 16px;
  border-top: 1px solid ${tokens.stroke.divider};
  border-bottom-left-radius: ${borderRadiusSystem.md}px;
  border-bottom-right-radius: ${borderRadiusSystem.md}px;

  [class^='ri-'],
  [class*=' ri-'] {
    cursor: pointer;
    color: ${tokens['fg-low']};

    &:hover {
      color: ${tokens.fg};
    }
  }
`

export const GridTableBtnList = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`

export const ToolBarButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const OptionButtonContainer = styled.div`
  position: relative;
`

export const OptionDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  background-color: ${colors.white};
  border: 1px solid ${tokens.stroke.border};
  border-radius: ${borderRadiusSystem.sm}px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
`

export const OptionItem = styled.div<{ $disabled?: boolean }>`
  padding: 8px 12px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  background-color: ${colors.white};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ $disabled }) => ($disabled ? colors.white : tokens['bg-low'])};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${tokens.stroke.border};
  }
`
